import React from 'react';
import {UserRole} from '@types';

export const userContext = React.createContext<UserRole>({
    roles: [],
    isSuperAdmin: false,
    hasPermissionWithoutSA: false,
    modes: [],
    categories: [],
    userId: undefined,
    vigoUserId: undefined,
    staticConfig: {
        isOpen:true,
        ttile:'',
        content:''
    }
});
